import { render, staticRenderFns } from "./CardsViewDashboards.vue?vue&type=template&id=8b1c9506&scoped=true"
import script from "./CardsViewDashboards.vue?vue&type=script&lang=js"
export * from "./CardsViewDashboards.vue?vue&type=script&lang=js"
import style0 from "./CardsViewDashboards.vue?vue&type=style&index=0&id=8b1c9506&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c9506",
  null
  
)

export default component.exports